import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-10 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-144">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="bg-gradient-to-br from-navy-800 to-navy-900 border border-navy-600 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-145">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold-400 to-transparent opacity-50" data-id="element-146"></div>

        <div className="inline-flex items-center justify-center p-4 bg-navy-900 rounded-full mb-6 border border-navy-700 shadow-lg" data-id="element-147">
          <ShieldCheck className="w-12 h-12 text-gold-400" data-id="element-148" />
        </div>

        <h2 className="text-2xl md:text-4xl font-bold text-white mb-6" data-id="element-149">
          🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>

        <div className="space-y-4 text-lg text-blue-100 max-w-2xl mx-auto mb-8" data-id="element-150">
          <p data-id="element-151">Descargás los tomos. Los usás esta noche.</p>
          <p data-id="element-152">Si en 7 días no es lo que esperabas:</p>
          <p className="text-xl font-bold text-white bg-navy-900/50 py-3 px-6 rounded-xl inline-block border border-navy-700" data-id="element-153">
            devolución del 100% sin formularios, sin drama.
          </p>
          <p className="text-base" data-id="element-154">
            Escribís a{' '}
            <a href="mailto:soportemundorecursos@gmail.com" className="text-gold-400 hover:underline" data-id="element-155">
              soportemundorecursos@gmail.com
            </a>{' '}
            y listo.
          </p>
        </div>

        <div className="inline-block bg-green-900/30 text-green-400 border border-green-800/50 px-4 py-2 rounded-full text-sm font-medium" data-id="element-156">
          Tasa de devoluciones: menos del 1%.
        </div>
      </motion.div>
    </section>;
}